import { render, staticRenderFns } from "./compactToday.vue?vue&type=template&id=54ead6a5&scoped=true&"
import script from "./compactToday.vue?vue&type=script&lang=js&"
export * from "./compactToday.vue?vue&type=script&lang=js&"
import style0 from "./compactToday.vue?vue&type=style&index=0&id=54ead6a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ead6a5",
  null
  
)

export default component.exports